import { Button, Form } from "react-bootstrap"
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom"
import request from "../utils/request"
import routes from "../utils/routes"
import { useDispatch } from 'react-redux';
import { useState, useEffect, useCallback, useMemo } from 'react';
import dayjs from "dayjs";
import { formatMoney, toSentenceCase, validate } from '../utils/index';
import { ACTIONS } from "../redux/actions";
import formRender, { FormRenderMod } from './renderer';
import AzureBlob from "../utils/azureblob";
import { useSelector } from "react-redux";
import alert, { Redirect } from '../utils/alert';
import { AppModalFun, AppModalMod } from "./modal";
import Swal from "sweetalert2";


const STATUS = {
    CLOSED: "closed"
}

const noticePeriodOptions = [
    {
        value: "",
        label: ""
    },
    {
        value: "1 Week",
        label: "1 Week"
    },
    {
        value: "2 Weeks",
        label: "2 Weeks"
    },
    {
        value: "3 Weeks",
        label: "3 Weeks"
    },
    {
        value: "1 Month",
        label: "1 Month"
    },
    {
        value: "2 Months",
        label: "2 Months"
    },
    {
        value: "More than 2 Months",
        label: "More than 2 Months"
    }
]

const educationalOptions = [
    {
        value: "",
        label: ""
    },
    {
        label: "Professional",
        value: "Professional"
    },
    {
        label: "High School",
        value: "high-school"
    },
    {
        label: "Undergraduate",
        value: "undergraduate"
    },
    {
        label: "Graduate",
        value: "graduate"
    },
    {
        label: "Master's Degree",
        value: "masters"
    },
    {
        label: "Vocational",
        value: "vocational"
    }
]
const experienceOptions = [
    {
        value: "",
        label: ""
    },
    {
        label: "1-3 years",
        value: "1-3"
    },
    {
        label: "3-5 years",
        value: "3-5"
    },
    {
        label: "5-8 years",
        value: "5-8"
    },
    {
        label: "9 years and above",
        value: "10 years and above"
    }
]
const appInfoFormConfig = [{

    label: {
        label: "Expected Salary",
        requiredIcon: true,
        style: {
            color: "#5E5873",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",

        },
    },
    key: "expectedSalary",
    labelContainerStyle: { width: "40%" },
    inputContainerStyle: { width: '50%' },
    containerStyle: { display: "flex" },
    type: "number",
    placeholder: "Monthly",
    required: true,
    onChange: () => { }
},
{
    label: {
        label: "Notice Period",
        requiredIcon: true,
        style: {
            color: "#5E5873",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal"
        },
    },
    key: "noticePeriod",
    labelContainerStyle: { width: "40%" },
    inputContainerStyle: { width: '50%' },
    containerStyle: { display: "flex" },
    type: "select",
    options: noticePeriodOptions,
    required: true,
    onChange: () => { }
},

{
    label: {
        label: "Cover letter",

        style: {
            color: "#5E5873",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal"
        },
    },
    key: "coverLetter",
    labelContainerStyle: { width: "20%" },
    inputContainerStyle: { width: '80%' },
    containerStyle: { display: "flex" },
    type: "textarea",
    rows: 5,
    onChange: () => { }
},
{
    label: {
        label: "Additional Information",
        style: {
            color: "#5E5873",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal"
        },

    },
    key: "otherInformation",
    labelContainerStyle: { width: "20%" },
    inputContainerStyle: { width: '80%' },
    containerStyle: { display: "flex" },
    type: "textarea",
    rows: 5,
    onChange: () => { }
}
]

const validations = {
    jobOpportunityID: {
        required: true
    },
    trackerId: {
        required: true
    },
    companyID: {
        required: true
    },
    resumeUrl: {
        title: "CV",
        required: true
    },
    fullName: {
        required: true
    },
    email: {
        required: true,
        isEmail: true
    },
    phone: {
        required: true
    },
    address: {
        required: true
    },

    educationalLevel: {
        title: "Educational Level",
        // required: true
    },
    yearsOfExperience: {
        title: "Years of Experience",
        // required: true
    },
    dateOfBirth: {
        required: true
    },
    gender: {
        required: true
    },
    acceptDataProtection: {
        title: "Data Protection",
        custom: (props: any) => {
            const { field, value } = props || {};
            if (value === "" || value === undefined || value === null) {
                return { status: false, message: `Data Protection is required` }
            }
            return { status: true }
        }
    },
    expectedSalary: {
        title: "Expected Salary",
        required: true
    },
    periodOfNotice: {
        title: "Period of Notice",
        required: true
    },
    acceptPrivacyPolicy: {
        title: "Privacy Policy"
    }
}

const types = {
    "ACCEPT": "accept",
    "REJECT": "reject",
    "ONBOARD": "onboard",
    "APPLY": "apply"
}

export default function JobDescription({ secured, job, offerId, isApplicationView }: any) {
    const { id: paramId } = useParams();
    const dispatch = useDispatch();
    const [data, setData] = useState<any>(job|| {});
    const [formData, setFormData] = useState<any>({})
    const [message, setErrorMessage] = useState('')
    const location = useLocation();
    const user = useSelector((state: any) => state.appReducer.userInfo) || {};
    const [modal, setModal] = useState<any>('');
    const jobs = data?.jobs || [];
    const application = jobs[0]
    const hiringChecklist = application?.hiringChecklists?.filter((v: any) => v.isCompleted) || [];
    const onBoardingChecklist = application?.onboardingChecklists?.filter((v: any) => v.isCompleted) || [];
    const navigate = useNavigate();
    const effectiveId = offerId || paramId;
    const profileScore = useSelector((state: any) => state.appReducer.profileScore);


    const getJob = useCallback(async () => {
        if (!effectiveId) {
            console.error("No job ID available for fetching job details.");
            return;
        }
    
        try {
            const result = await request({
                url: secured ? `${routes["MyjobList"]}/${effectiveId}` : `${routes["jobList"]}/${effectiveId}`,
                method: "GET",
                dispatch,
                navigate,
            });
    
            if (result?.statusCode === 200) {
                if (!result?.payload.data.length) {
                    alert({
                        title: "Job Not Found"
                    }).then(() => navigate("/"));
                } else {
                    setData(result?.payload.data[0] || {});
                }
            }
        } catch (error) {
            console.error("Error fetching job details:", error);
        }
        
    },[dispatch, effectiveId,navigate, secured])

    const getApplicationInfo = useCallback(async (type: string) => {
        const result = await request({
            url: `${routes["MyjobList"]}/${offerId}/${application._id}`,
            method: "GET",
            dispatch,
            navigate
        })
        if (result?.statusCode === 200) {
            const { hiringChecklists = [], onboardingChecklists = [] } = result?.payload;
            const checklist = type === types.ACCEPT ? hiringChecklists : onboardingChecklists;
            const data = [];
            for (let list of checklist) {
                data.push({
                    id: list._id,
                    name: list?.checklistID?.name || "",
                    docUrl: ''
                })
            }
            setFormData({ checklists: data })
        }
    },[application?._id, dispatch, navigate, offerId])

    useEffect(() => {
        if (job?._id) {
            setData(job);
            // setFormData({ ...formData, ...job });
        }
        else if (effectiveId) {
            getJob().catch(console.error);
        }
    }, [effectiveId, job, formData, getJob]);

    useEffect(() => {
        if (data?.companyName) {
            window.document.title = `${toSentenceCase(data?.jobRole?.name || "")}@${toSentenceCase(data.companyName || "")}`;
        }
    }, [data])

    const onChange = useCallback(async (e: any, val?: null | boolean) => {
        const { name, files = [], value } = e.target
        if (typeof val == "boolean") {
            setFormData((prev: any) => ({ ...prev, [name]: val }))
            return;
        }
        setFormData((prev: any) => ({ ...prev, [name]: files?.length ? URL.createObjectURL(files[0]) : value }))
    },[])

    const jobFinalCheck = useMemo(() => {
        const { additionalDocsUrl = [] } = formData;
        const customQuestions = data?.customQuestions || [];

        if (!data?.additionalDocuments) {
            return null;
        }
        return <>
            <div className="mb-3">
                <div className="d-flex  p-3 h-100 flex-column w-100" >
                    <div className="d-flex justify-content-between desc-jobrole-div">
                        <h1 className="job-desc-jobrole">
                            {toSentenceCase(data?.jobRole?.name || '')}
                        </h1>

                    </div>
                    <div className="d-flex justify-content-between">
                        <span className="text-uppercase desc-name">
                            {data.location} / {data.companyName} / {data.hiringDepartment.name}
                        </span>

                    </div>
                </div>
            </div>

            <div className="mb-3 ">
                <div className="salary-notice-flex-container" style={{ display: 'flex', marginBottom: '20px' }}>
                    <div className="form-field" style={{ marginRight: '20px', flexGrow: 1 }}>
                        <div className="label-container" style={appInfoFormConfig.find(f => f.key === 'expectedSalary')?.labelContainerStyle}>
                            <label style={appInfoFormConfig.find(f => f.key === 'expectedSalary')?.label?.style}>
                                {appInfoFormConfig.find(f => f.key === 'expectedSalary')?.label?.label}
                                {appInfoFormConfig.find(f => f.key === 'expectedSalary')?.label?.requiredIcon && <span className="text-danger">*</span>}
                            </label>
                        </div>

                        {formRender({
                            ...appInfoFormConfig.find(f => f.key === 'expectedSalary'),
                            returnOnlyInput: true,
                            binder:
                                formData['expectedSalary'],
                            onChange: onChange
                        })}
                    </div>

                    <div className="form-field" style={{ flexGrow: 1 }}>
                        <div className="label-container" style={appInfoFormConfig.find(f => f.key === 'noticePeriod')?.labelContainerStyle}>
                            <label style={appInfoFormConfig.find(f => f.key === 'noticePeriod')?.label?.style}>
                                {appInfoFormConfig.find(f => f.key === 'noticePeriod')?.label?.label}
                                {appInfoFormConfig.find(f => f.key === 'noticePeriod')?.label?.requiredIcon && <span className="text-danger">*</span>}
                            </label>
                        </div>

                        {formRender({
                            ...appInfoFormConfig.find(f => f.key === 'noticePeriod'),
                            returnOnlyInput: true,
                            binder: formData['noticePeriod'],
                            onChange: onChange
                        })}
                    </div>
                </div>
                {appInfoFormConfig.map((value, i) => {
                    if (value.key !== 'expectedSalary' && value.key !== 'noticePeriod') {
                        return (
                            <div key={i} className="form-field" style={{ marginBottom: '20px' }}>
                                <div className="label-container">
                                    <label style={value.label.style}>
                                        {value.label.label}
                                        {value.label.requiredIcon && <span className="text-danger">*</span>}
                                    </label>
                                </div>
                                {formRender({
                                    ...value,
                                    returnOnlyInput: true,
                                    binder: formData[value.key],
                                    onChange: onChange
                                })}
                            </div>
                        );
                    }
                    return null;
                })}


            </div>
            <div className="custom-questions-container">
                {customQuestions.map((value: any, i: number) => {
                    return (
                        <div key={value._id} className="custom-question">
                            <div className="custom-question-label">{value.question}</div>
                            {formRender({
                                labelContainerStyle: { display: "none" }, // Hide the label if it's rendered inside formRender
                                inputContainerStyle: { width: '100%' },
                                containerStyle: { display: "flex", flexDirection: "column" },
                                type: "text",
                                key: value._id,
                                label: value.question,
                                binder: formData[value._id],
                                onChange: onChange
                            })}
                            <hr className="custom-question-divider" />
                        </div>
                    );
                })}
            </div>



            {additionalDocsUrl.length ?
                <div className="mb-3">
                    <h6 className="text-bold mt-2 mb-3"> Documents Required </h6>
                    {
                        formRender({
                            defaultFiles: additionalDocsUrl.map((value: any) => ({ ...value, editable: false })),
                            returnOnlyInput: true,
                            name: "additionalDocsUrl",
                            folder: "otherDocs",
                            useAddMore: false,
                            type: "customFile",
                            onChange: (files: any[]) => {
                                const actualFiles = [];
                                for (let item of files) {
                                    actualFiles.push({
                                        id: item.id,
                                        name: item.name,
                                        url: item.url,
                                        docUrl: item.url
                                    })

                                }
                                onChange({ target: { value: actualFiles, name: "additionalDocsUrl" } })
                            }

                        })
                    }
                    {/* <hr /> */}
                </div> : null}
            <div className="mb-3 data-protection-div">
                <h6 className="text-bold mt-2 mb-3 application-body-head"> Terms And Condition </h6>
                <p className="application-body"><span className="text-bold">Data Protection</span>: I agree that my candidate data will be recorded in the applicant pool and that {data.companyName} can contact me about future job opportunities for up to 1 year.</p>
                <Form.Check
                    name="acceptDataProtection"
                    type={"radio"}
                    className="application-body"

                    onChange={(e) => onChange(e, true)}
                    label={`Yes, I agree`}
                />
                <Form.Check
                    name="acceptDataProtection"
                    type={"radio"}
                    className="application-body"
                    onChange={(e) => onChange(e, false)}
                    label={`No, I disagree`}
                />

            </div>
        </>
    }, [formData,onChange, data])

    const hiringFinalCheck = useMemo(() => {
        const { checklists = [] } = formData;
        if (modal === 'reject') {
            return <>
                <p>
                    <b>
                        You are about to reject an offer from {data.companyName}
                    </b>
                </p>
            </>
        }

        if (!Object.keys(formData).length) {
            return null;
        }

        return <>
            <div className="m-1">
                <p>
                    <b>
                        You have recieved an offer from {data.companyName}. Please go through the terms and requirements.
                    </b>
                </p>
            </div>
            {
                checklists.length ?
                    <div className="mb-3">
                        <h6 className="text-bold mt-2 mb-3 label-address"> Hiring Documents </h6>
                        {
                            formRender({
                                defaultFiles: checklists.map((value: any) => ({ ...value, editable: false })),
                                returnOnlyInput: true,
                                name: "checklists",
                                folder: "otherDocs",
                                useAddMore: false,
                                type: "customFile",
                                onChange: (files: any[]) => {
                                    const actualFiles = [];
                                    for (let item of files) {
                                        actualFiles.push({
                                            id: item.id,
                                            name: item.name,
                                            url: item.url,
                                            docUrl: item.url
                                        })

                                    }
                                    onChange({ target: { value: actualFiles, name: "checklists" } })
                                }

                            })
                        }
                        < hr />
                    </div> : null
            }
            <div className="mb-3">
                <div className="d-flex mt-5">
                    <Form.Check
                        name="acceptOffer"
                        className=" custom-question-label"
                        type={"checkbox"}
                        onChange={(e) => onChange(e, !formData["acceptOffer"])}
                        label={`Yes, I accept this offer`}
                    />
                </div>
            </div>
        </>
    }, [formData, data,onChange, modal])

    const onBoardingCheck = useMemo(() => {
        const { checklists = [] } = formData;
        if (!Object.keys(formData).length) {
            return null;
        }
        return <>
            <div className="m-1">
                <p>
                    <b>
                        {data.companyName} has invited you to onboard. Please upload all necessary documents
                    </b>
                </p>
            </div>
            {
                checklists.length ?
                    <div className="mb-3">
                        <h6 className="text-bold mt-2 mb-3"> OnBoarding Documents </h6>
                        {
                            formRender({
                                defaultFiles: checklists.map((value: any) => ({ ...value, editable: false })),
                                returnOnlyInput: true,
                                name: "checklists",
                                folder: "otherDocs",
                                useAddMore: false,
                                type: "customFile",
                                onChange: (files: any[]) => {
                                    const actualFiles = [];
                                    for (let item of files) {
                                        actualFiles.push({
                                            id: item.id,
                                            name: item.name,
                                            url: item.url,
                                            docUrl: item.url
                                        })

                                    }
                                    onChange({ target: { value: actualFiles, name: "checklists" } })
                                }

                            })
                        }
                        < hr />
                    </div> : null
            }
            <div className="mb-3">
                <div className="d-flex mt-5">
                    <Form.Check
                        name="acceptOffer"
                        type={"checkbox"}
                        onChange={(e) => onChange(e, !formData["acceptOffer"])}
                        label={`Yes, this documents are correct to the best of my knowledge`}
                    />
                </div>
            </div>
        </>
    }, [formData,onChange, data])

    const saveApplication = useCallback( async (props: any) => {

        //  const { formData } = props || {}
        const payload: any = {
            jobOpportunityID: data?._id,
            trackerId: user._id,
            companyID: data.companyID,
            resumeUrl: user.resumeUrl,
            fullName: `${user.firstName} ${user.lastName}`,
            email: user.email,
            phone: user.phone,
            address: user.address,
            location: user.location,
            passportUrl: user.passportUrl,
            currentCompany: user.currentCompany,
            linkedinUrl: user.linkedinUrl,
            githubUrl: user.githubUrl,
            portfolioUrl: user.portfolioUrl,
            specialty: user.occupation,
            educationalLevel: formData.educationalLevel,
            yearsOfExperience: formData.yearsOfExperience,
            educationalInformation: user.educationalInformation,
            workExperience: user.workExperience,
            dateOfBirth: user.dateOfBirth,
            gender: user.gender,
            certificateUrl: user.certificateUrl.map((v: any) => v.url),
            acceptDataProtection: formData.acceptDataProtection,
            expectedSalary: formData.expectedSalary,
            periodOfNotice: formData.noticePeriod,
            acceptPrivacyPolicy: formData.acceptPrivacyPolicy,
            additionalInformation: formData.additionalInformation,
            coverLetter: formData.coverLetter,
            additionalDocsUrl: formData.additionalDocsUrl.map((v: any) => v.url),
            otherSkills: user.otherSkills
        }

        if (data?.additionalDocs?.length) {
            for (let item of formData.additionalDocsUrl) {
                if (!item["url"]) {
                    setErrorMessage(`Please upload file for ${item["name"]}`)
                    throw Error(`Please upload file for ${item["name"]}`)
                }
            }
        }


        let customQuestions = [];
        if (data?.customQuestions?.length) {
            for (let item of data?.customQuestions) {
                if (!formData[item._id]) {
                    setErrorMessage(`Please give a response for ${item["question"]}`)
                    throw Error(`Please give a response for ${item["question"]}`)
                }
                customQuestions.push({
                    id: item._id,
                    answer: formData[item._id]
                })
            }
        }
        payload.customQuestions = customQuestions;

        const validationResult = validate(validations, payload);
        if (validationResult) {
            setErrorMessage(validationResult)
            throw Error(validationResult)
        }
        setErrorMessage('')

        const result = await request({
            url: routes.apply,
            method: "POST",
            dispatch,
            navigate,
            data: payload
        })
        if (result?.statusCode === 200) {
            alert({
                title: "Application Submitted",
                icon: 'success'
            })
            setModal('');
            setFormData({});
            navigate("/");
        }
    },[data,user, dispatch, formData, navigate])

    const onChecklist = useCallback((type: "accept" | "onboard" | string) => {
        const messages: any = {
            "accept": {
                route: routes.accept,
                checkbox: "Please accept the offer",
                alert: {
                    title: "Offer Accepted",
                    text: "You have accepted Offer! Congratulations",
                    icon: "success"
                }
            },
            onboard: {
                route: routes.onboard,
                checkbox: "Please acknowledge that documents are correct",
                alert: {
                    title: "Onboarding Completed",
                    text: "You have successfully onboarded",
                    icon: "success"
                }
            }
        }
        return async (props: any) => {
            const { checklists = [], acceptOffer } = formData;
            const msg = messages[type];
            for (let item of checklists) {
                if (!item.docUrl) {
                    setErrorMessage(` Please select a File for ${item.name} `)
                    throw new Error(` Please select a File for ${item.name} `)
                }
            }
            if (!acceptOffer) {
                setErrorMessage(msg.checkbox)
                throw new Error(msg.checkbox)
            }
            setErrorMessage('')
            const result = await request({
                url: `${msg.route}/${application._id}`,
                method: "POST",
                dispatch,
                navigate,
                data: formData
            })
            if (result?.statusCode === 200) {
                alert(msg.alert)
                setModal('')
                getJob().catch()
            }
        }
    },[application?._id, dispatch, formData, getJob, navigate])

    const rejectOffer = useCallback(async (props: any) => {
        const result = await request({
            url: `${routes.reject}`,
            method: "POST",
            dispatch,
            navigate,
            data: {
                applicantID: application._id
            }
        })
        if (result?.statusCode === 200) {
            alert({
                title: "Reject Offer",
                text: "You have Rejected Offer",
                icon: "success"
            })
            setModal('')
            getJob().catch()
        }
    },[application?._id, dispatch, getJob, navigate])

    const validUser = (user: any) => {
        const keys: any = {
            "firstName": "First Name",
            "lastName": "Last Name",
            "email": "Email",
            "resumeUrl": "Resume",
            "address": "Address",
            "gender": "Gender",
            "phone": "Phone Number",
        }
        let invalidKeys = [];
        for (let key in keys) {
            if (!user[key]?.length) {
                invalidKeys.push(keys[key])
            }
        }

        return invalidKeys;

    }

    const apply = useCallback((type: string) => {
        if (!Object.keys(user).length) {
            return Redirect({ navigate, location })
        }
        const isValidUser = validUser(user);
        if (isValidUser.length) {
            return Swal.fire({
                showCancelButton: true,
                title: "Incomplete Profile",
                text: `The following information - ${isValidUser.join(",")} has not been provided. Do you want to go to your Profile? `
            }).then((value) => {
                if (value.isConfirmed) {
                    navigate("/my-profile")
                }
            })
        }
        setModal(type);
        if (type === types.APPLY) {
            const { additionalDocs = [] } = data || {};
            let temp = [];
            for (let item of additionalDocs) {
                temp.push({
                    name: item,
                    url: ""
                })
            }
            setFormData({ additionalDocsUrl: temp })
        }
        if ([types.ACCEPT, types.ONBOARD].includes(type)) {

            getApplicationInfo(type).catch()

        }
    },[data, getApplicationInfo, location, navigate,user])

    const btn = () => {
        if (application?.onboardingStatus === "completed") {
            return <Button style={{ width: "fit-content" }} className="max-height-40 btn-success" variant={"info"} disabled={true} >OnBoarded</Button>
        }
        if (application?.onboardingStatus === "pending") {
            return <div className="d-flex">
                <Button style={{ width: "fit-content" }} className="max-height-40 btn-success" onClick={() => navigate(`/onboarding/${application._id}`)}  >
                    On Board
                </Button>
            </div>
        }
        if (application?.isAccepted) {
            return <Button style={{ width: "fit-content" }} className="max-height-40 btn-success" variant={"info"} disabled={true} >Offer Accepted</Button>
        }
        if (application?.isRejected) {
            return <Button style={{ width: "fit-content" }} className="max-height-40 btn-success" variant="danger" disabled={true} >Offer Rejected</Button>
        }
        if (application?.isHired) {
            return <div className="d-flex">
                <Button style={{ width: "fit-content" }} className="max-height-40 btn-success accept-offer-btn" onClick={() => apply('accept')}  >
                    Accept Offer
                </Button>
                <Button style={{ width: "fit-content" }} className="max-height-40 btn-danger reject-offer-btn" onClick={() => apply('reject')}  >
                    Reject Offer
                </Button>
            </div>
        }

        if (isApplicationView && data?.status === STATUS.CLOSED) {
            return <Button style={{ width: "fit-content" }} className="max-height-40 job-desc-apply" disabled={true}>
                Applied
            </Button>
        }

        if (data?.status === STATUS.CLOSED) {
            return <Button style={{ width: "fit-content" }} className="max-height-40 btn-secondary" disabled={true}>
                Closed
            </Button>
        }

        if (application?.isInvited) {
            return <Button style={{ width: "fit-content" }} className="max-height-40 btn-success" variant="info" disabled={true} >Invited</Button>
        }

        return <Button className=" job-desc-apply" onClick={() => apply('apply')} disabled={data?.jobs?.length} >
            {data?.jobs?.length ? "Applied" : "Apply"}
        </Button>

    }


    return <>
        {data && Object.keys(data).length > 0 ?
            <div className="d-flex  shadow-sm p-3 h-100 flex-column w-100" >
                <div className="d-flex justify-content-between desc-jobrole-div">
                    <h1 className="job-desc-jobrole">
                        {toSentenceCase(data?.jobRole?.name||'')}
                    </h1>
                    {btn()}
                </div>
                <div className="d-flex justify-content-between">
                    <span className="text-uppercase desc-name">
                        {data.location} / {data.companyName} / {data.hiringDepartment.name}
                    </span>
                    <span className="text-right desc-name">
                        Date Posted: {dayjs(data?.createdOn).format("DD/MM/YYYY")}
                    </span>
                </div>
                <hr />


                <div className="d-flex flex-column mt-3 job-description-template">
                    <div dangerouslySetInnerHTML={{ __html: data.jobDescription }}></div>
                </div>

                <div className="d-flex flex-column mt-5">
                    <p className="job-details-div">
                        <span className="job-details">Required Educational Level</span>:
                        <span className="job-details-text"> {toSentenceCase(data.educationalLevel)}</span>
                    </p>
                    <p className="job-details-div">
                        <span className="job-details">Experience Level</span>:
                        <span className="job-details-text"> {toSentenceCase(data.experienceLevel)}</span>
                    </p>
                    <p className="job-details-div">
                        <span className="job-details">Job Type</span>:
                        <span className="job-details-text"> {data.jobType.map((type: any) => toSentenceCase(type)).join(", ")}</span>
                    </p>
                    <p className="job-details-div">
                        <span className="job-details">Job Role Type</span>:
                        <span className="job-details-text"> {toSentenceCase(data.jobRoleType)}</span>
                    </p>
                    <p className="job-details-div">
                        <span className="job-details">Location</span>:
                        <span className="job-details-text"> {toSentenceCase(data.location)}</span>
                    </p>
                    <p className="job-details div" ><span className="job-details">Skills Required</span>:
                        <span className="job-details-text">  {data.skills.map((v: any) => toSentenceCase(v.name)).join(" , ")}</span>
                    </p>
                    {data.showSalary ?
                        <p className="job-details-div">
                            <span className="job-details">Salary</span>:
                            <span className="job-details-text">
                                {` ${formatMoney(data.salaryLowerAmount)} - ${formatMoney(data.salaryUpperAmount)}`}
                            </span>
                        </p>
                        : null
                    }
                    {btn()}


                    {modal === "apply" && (
                        <AppModalFun
                            show={modal === "apply"}
                            onHide={() => { setModal(''); setErrorMessage(''); setFormData({}) }}
                            title="Submit Application"
                            onSave={saveApplication}
                            profileProgress={profileScore}
                        >
                            {jobFinalCheck}
                        </AppModalFun>
                    )}

                    {modal === "accept" && (
                        <AppModalFun
                            show={modal === "accept"}
                            onHide={() => { setModal(''); setErrorMessage(''); setFormData({}) }}
                            onSave={onChecklist(types.ACCEPT)}
                            onClickTitle='Accept'
                            title={`Accept  Offer  (${toSentenceCase(data?.jobRole?.name || "")})`}
                            message={message} setMessage={setErrorMessage}
                        >
                            {hiringFinalCheck}
                        </AppModalFun>
                    )}

                    {modal === "reject" && (
                        <AppModalFun
                            show={modal === "reject"}
                            onHide={() => { setModal(''); setErrorMessage(''); setFormData({}) }}
                            onSave={rejectOffer}
                            onClickTitle='Reject'
                            title={`Reject Offer (${toSentenceCase(data?.jobRole?.name || "")})`}
                            message={message} setMessage={setErrorMessage}
                        >
                            {hiringFinalCheck}
                        </AppModalFun>
                    )}
                    {/* {modal === "onboard" ?
                        <AppModalMod show={modal === "onboard"}
                         size={"lg"} centered={"centered"}
                          onClick={onChecklist(types.ONBOARD)}
                           closeModal={(() => { setModal(''); setErrorMessage(''); setFormData({}) })}
                            onClickTitle='OnBoard'
                             title={`  (${toSentenceCase(data?.jobRole?.name || "")}) Onboarding`}
                              message={message} setMessage={setErrorMessage}   >
                            <>{onBoardingCheck}</>
                        </AppModalMod> : null
                    } */}
                    {modal === "onboard" && (
                        <AppModalFun
                            show={modal === "onboard"}
                            onHide={() => { setModal(''); setErrorMessage(''); setFormData({}) }}
                            onSave={onChecklist(types.ONBOARD)}
                            onClickTitle='OnBoard'
                            title={`  (${toSentenceCase(data?.jobRole?.name || "")}) Onboarding`}
                            message={message} setMessage={setErrorMessage}
                        >
                            {onBoardingCheck}
                        </AppModalFun>
                    )}
                </div>

            </div > : null
        }
    </>
}
